module.exports = __webpack_public_path__ + "img/ico_search_up.bf75dfea.svg";